import { useEffect, useCallback, useRef } from 'react';
import { useNotesTab } from '../context';

export const useNotesTabPage = () => {
  const {
    notes,
    meta,
    loading,
    error,
    filters,
    selectedIds,
    selectAll,
    hasActiveFilters,
    selectedCount,
    contactId,
    fetchNotes,
    updateFilters,
    clearFilters,
    toggleSelect,
    toggleSelectAll,
    clearSelection,
    handlePageChange,
    handleItemsPerPageChange,
    createNote,
    getNoteDetail,
    updateNote,
    deleteNote,
    pinNote,
  } = useNotesTab();

  // Track initial fetch and contact changes
  const initialFetchDone = useRef(false);
  const lastContactIdRef = useRef(null);

  // Initial fetch on mount or when contactId changes
  useEffect(() => {
    if (contactId) {
      if (lastContactIdRef.current !== contactId) {
        lastContactIdRef.current = contactId;
        initialFetchDone.current = true;
        fetchNotes(1);
      }
    }
  }, [contactId, fetchNotes]);

  // Refetch when filters change (but not on initial mount)
  useEffect(() => {
    if (!initialFetchDone.current) return;
    fetchNotes(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.search, filters.category]);

  // Filter handlers
  const handleSearchChange = useCallback(
    (value) => {
      updateFilters({ search: value });
    },
    [updateFilters]
  );

  const handleCategoryChange = useCallback(
    (value) => {
      updateFilters({ category: value });
    },
    [updateFilters]
  );

  // Refresh handler
  const handleRefresh = useCallback(() => {
    fetchNotes(meta.current_page, meta.per_page);
  }, [fetchNotes, meta.current_page, meta.per_page]);

  return {
    // State
    notes,
    meta,
    loading,
    error,
    filters,
    selectedIds,
    selectAll,
    hasActiveFilters,
    selectedCount,

    // Filter handlers
    handleSearchChange,
    handleCategoryChange,

    // Selection
    toggleSelect,
    toggleSelectAll,
    clearSelection,

    // Pagination
    handlePageChange,
    handleItemsPerPageChange,

    // CRUD
    createNote,
    getNoteDetail,
    updateNote,
    deleteNote,
    pinNote,

    // Other
    handleRefresh,
    clearFilters,
  };
};

export default useNotesTabPage;
